import { computed, useAttrs } from "vue";

export function useFallthroughProps<T extends object> (props: T) {
  return computed(() => ({
    ...props,
    ...Object.fromEntries(Object.entries(useAttrs()).filter(([name,]) => name.match(/^on[A-Z]/) || name === 'class' || name === 'style'))
  }))
}